import Vue from 'vue';
import { Draggable } from '@shopify/draggable';
import { store } from '@/store';
import json from '@/main.json';
import router from '@/router';
import axios from 'axios';

Vue.directive('draggable', {
  bind(el) {
    let lastEl;
    let current_level;
    let correct_items;
    let part_head_items;
    let part_torso_items;
    let part_hand_items;
    let part_feet_items;
    // console.log(router.history.current.params.level);
    // console.log(router.history.current.path);
    // console.log(json.levels.one.correct_items);
    switch (router.history.current.params.level) {
      case 'logistics':
        current_level = 'logistics'
        correct_items = json.levels.one.correct_items;
        part_head_items = json.levels.one.part_head_items;
        part_torso_items = json.levels.one.part_torso_items;
        part_hand_items = json.levels.one.part_hand_items;
        part_feet_items = json.levels.one.part_feet_items;
        break;
      case 'lab':
        current_level = 'lab'
        correct_items = json.levels.two.correct_items;
        part_head_items = json.levels.two.part_head_items;
        part_torso_items = json.levels.two.part_torso_items;
        part_hand_items = json.levels.two.part_hand_items;
        part_feet_items = json.levels.two.part_feet_items;
        break;
      case 'construction':
        current_level = 'construction'
        correct_items = json.levels.three.correct_items;
        part_head_items = json.levels.three.part_head_items;
        part_torso_items = json.levels.three.part_torso_items;
        part_hand_items = json.levels.three.part_hand_items;
        part_feet_items = json.levels.three.part_feet_items;
        break;
    }
    let currTarget = {
      target: "",
      correct: ""
    };
    const draggable = new Draggable(el, {
      draggable: 'li'
    });

    // add pulsing circle to the target
    const addPulse = function (target) {
      document.querySelector(target).style['display'] = 'block';
      document.querySelector(target).classList.add('animated');
    };

    // remove pulsing circle on the target
    const removePulse = function (target) {
      setTimeout(function () {
        document.querySelector(target).classList.remove('animated');
        document.querySelector(target).style['display'] = 'none';
      }, 2400);
    }

    const isempty = function (x) { if (x !== "") return true; }

    // run on the drag:move event
    draggable.on('drag:move', function (e) {
      lastEl = e.data.sensorEvent.data.target;
      currTarget.target = e.data.source.dataset.target;
      currTarget.id = e.data.source.dataset.id;
      currTarget.correct = e.data.source.dataset.correct;
      if (lastEl.id === 'CIRCLE-HEAD' || lastEl.id === 'CIRCLE-BODY' || lastEl.id === 'CIRCLE-RIGHT-HAND-2' || lastEl.id === 'CIRCLE-LEFT-HAND-2' || lastEl.id === 'CIRCLE-FEET') {
        addPulse('#target_head');
        addPulse('#target_torso');
        addPulse('#target_hand');
        addPulse('#target_feet');
      }
      else {
        removeAllPulses();
      }
    });

    // update svg classes to the correct format
    const updateClasses = () => {
      if (JSON.parse(localStorage.getItem('characterItems')).includes('bui-hardhat')) {
        document.querySelector('svg').classList.remove('g-nohardhat');
        document.querySelector('svg').classList.add('g-hardhat');
      } else {
        document.querySelector('svg').classList.remove('g-hardhat');
        document.querySelector('svg').classList.add('g-nohardhat');
      }

      if (JSON.parse(localStorage.getItem('characterItems')).includes('log-fleecejacket')) {
        document.querySelector('svg').classList.remove('g-nofleecejacket');
        document.querySelector('svg').classList.add('g-fleecejacket');
      } else {
        document.querySelector('svg').classList.remove('g-fleecejacket');
        document.querySelector('svg').classList.add('g-nofleecejacket');
      }
    }

    // compare difference between two array and return true or false
    const compare = function (array1, array2) {
      var temp = [];
      for (var i in array1) {
        if (array2.indexOf(array1[i]) === -1) temp.push(array1[i]);
      }
      for (i in array2) {
        if (array1.indexOf(array2[i]) === -1) temp.push(array2[i]);
      }
      return temp.sort((a, b) => a - b).length == 0 ? true : false;
    }

    // compare difference between two arrays and return if matching elements
    const containsAllItems = function (needle, haystack) {
      for (var i = 0; i < needle.length; i++) {
        if (haystack.indexOf(needle[i]) === -1)
          return false;
      }
      return true;
    };

    // compare difference between two arrays and return if atleast one matching element
    const containsSomeItems = function (arr, haystack) {
      return arr.some(function (v) {
        return haystack.indexOf(v) >= 0;
      });
    };

    // remove answer pop up notification
    const removeNotification = () => {
      setTimeout(function () {
        store.commit('set_item_correct', null);
      }, 2400);
    }

    // remove answer pop up notification
    const removeMessage = () => {
      setTimeout(function () {
        store.commit('set_message', null);
      }, 2400);
    }

    // remove all pulses
    const removeAllPulses = () => {
      removePulse('#target_head');
      removePulse('#target_torso');
      removePulse('#target_hand');
      removePulse('#target_feet');
    }

    // add correct item class
    const addCorrectItemClass = (target) => {
      setTimeout(function () {
        document.querySelectorAll("#img-" + target).forEach(function (e) {
          e.classList.add('correct_item');
        });
      }, 1000)
    }

    // reset store states to null
    const resetStores = function () {
      store.commit('set_part_head_correct', null)
      store.commit('set_part_torso_correct', null)
      store.commit('set_part_hand_correct', null)
      store.commit('set_part_feet_correct', null)
    }

    // add the item to the character if correct
    const showItems = () => {
      // console.log(currTarget.id);
      // console.log(document.querySelector("[data-id='"+currTarget.id+"']"));

      let newItems = JSON.parse(localStorage.getItem('characterItems')) ? JSON.parse(localStorage.getItem('characterItems')) : [];
      !newItems ? newItems.push(currTarget.id) : null;
      // console.log('Current Target ID ' + currTarget.id);
      store.commit('set_item_correct', 'true');
      removeNotification();
      !newItems.includes(currTarget.id) ? newItems.push(currTarget.id) : null;
      localStorage.setItem('characterItems', JSON.stringify(newItems));
      updateClasses();
      for (let i = 0; i < document.querySelectorAll('.' + currTarget.id + '').length; i++) {
        document.querySelectorAll('.' + currTarget.id + '')[i].style.display = 'block';
      }
      removeAllPulses();
      var res = newItems.filter(isempty);

      containsSomeItems(part_head_items, res) ? store.commit('set_part_head_correct', 'some') : store.commit('set_part_head_correct', null);
      containsAllItems(part_head_items, res) ? store.commit('set_part_head_correct', 'all') : null;
      containsSomeItems(part_torso_items, res) ? store.commit('set_part_torso_correct', 'some') : store.commit('set_part_torso_correct', null);
      containsAllItems(part_torso_items, res) ? store.commit('set_part_torso_correct', 'all') : null;
      containsSomeItems(part_hand_items, res) ? store.commit('set_part_hand_correct', 'some') : store.commit('set_part_hand_correct', null);
      containsAllItems(part_hand_items, res) ? store.commit('set_part_hand_correct', 'all') : null;
      containsSomeItems(part_feet_items, res) ? store.commit('set_part_feet_correct', 'some') : store.commit('set_part_feet_correct', null);
      containsAllItems(part_feet_items, res) ? store.commit('set_part_feet_correct', 'all') : null;

      if (compare(res, correct_items)) {
        let session = '';
        (sessionStorage.getItem('rs-session-key')) && (session = JSON.parse(sessionStorage.getItem('rs-session-key')));
        (sessionStorage.getItem('vue-session-key')) && (session = JSON.parse(sessionStorage.getItem('vue-session-key')));
        let get_id = session.session_play;
        let data = {
          user: get_id,
          current_level: current_level,
          status: current_level === 'construction' ? 1 : 0
        };
        axios({
          method: 'POST',
          url: 'https://influencedigital.app/rscomponents/rs-frgame/de/api/v1/tc',
          data: data,
          headers: {
            "content-type": "application/x-www-form-urlencoded"
          }
        }).then(response => {
          console.log(response);
        }).catch((error) => {
          console.log(error);
          console.log(error.response);
          console.log(error.response.data);
        });
        setTimeout(function () {
          router.push({ name: 'complete', params: { level: current_level } });
          resetStores();
          localStorage.setItem('characterItems', JSON.stringify(['']));
        }, 3000);
      }
    }

    // run on event drag:stop
    draggable.on('drag:stop', function () {
      // change the value of the current item state
      currTarget ? store.commit('set_item', currTarget.id) : null;
      // console.log('Current Item State: ' + store.state.item); // -> 1
      // check if correct items include item that was dragged
      var check_items = correct_items.includes(currTarget.id);
      // set correct value is true for item for the env.
      check_items ? lastEl.correct = true : null;
      // console.log(lastEl);

      if (lastEl.id === 'CIRCLE-HEAD' || lastEl.id === 'CIRCLE-BODY' || lastEl.id === 'CIRCLE-RIGHT-HAND-2' || lastEl.id === 'CIRCLE-LEFT-HAND-2' || lastEl.id === 'CIRCLE-FEET') {
        if (!check_items) {
          lastEl = '';
          // console.log('Wrong item');
          // alert("Wrong item, please try again");
          store.commit('set_item_correct', 'false');
          removeNotification();
          removeAllPulses();
        } else if (currTarget.target == 1 && lastEl.id === 'CIRCLE-HEAD') {
          lastEl = '';
          showItems();
          removePulse('#target_head');
          addCorrectItemClass(currTarget.id);
        } else if (currTarget.target == 2 && lastEl.id === 'CIRCLE-BODY') {
          lastEl = '';
          showItems();
          removePulse('#target_torso');
          addCorrectItemClass(currTarget.id);
        } else if ((currTarget.target == 3 && lastEl.id === 'CIRCLE-RIGHT-HAND-2') || (currTarget.target === 3 && lastEl.id === 'CIRCLE-LEFT-HAND-2')) {
          lastEl = '';
          showItems();
          removePulse('#target_hand');
          addCorrectItemClass(currTarget.id);
        } else if (currTarget.target == 4 && lastEl.id === 'CIRCLE-FEET') {
          lastEl = '';
          showItems();
          removePulse('#target_feet');
          addCorrectItemClass(currTarget.id);
        } else {
          // alert("Item does not match section of the body");
          lastEl = '';
          store.commit('set_item_correct', 'false');
          removeNotification();
          removeAllPulses();
        }
      }
    });

    setTimeout(function () {



      const updateItems = function (e) {
        if (correct_items.includes(e.dataset.id)) {

          let newItems = JSON.parse(localStorage.getItem('characterItems')) ? JSON.parse(localStorage.getItem('characterItems')) : [];
          // console.log('Current Target ID ' + currTarget.id);
          store.commit('set_item_correct', 'true');
          addCorrectItemClass(e.dataset.id);
          removeNotification();
          !newItems.includes(e.dataset.id) ? newItems.push(e.dataset.id) : null;
          localStorage.setItem('characterItems', JSON.stringify(newItems));
          updateClasses();

          for (let i = 0; i < document.querySelectorAll('.' + e.dataset.id + '').length; i++) {
            document.querySelectorAll('.' + e.dataset.id + '')[i].style.display = 'block';
          }

          var res = newItems.filter(isempty);

          containsSomeItems(part_head_items, res) ? store.commit('set_part_head_correct', 'some') : store.commit('set_part_head_correct', null);
          containsAllItems(part_head_items, res) ? store.commit('set_part_head_correct', 'all') : null;
          containsSomeItems(part_torso_items, res) ? store.commit('set_part_torso_correct', 'some') : store.commit('set_part_torso_correct', null);
          containsAllItems(part_torso_items, res) ? store.commit('set_part_torso_correct', 'all') : null;
          containsSomeItems(part_hand_items, res) ? store.commit('set_part_hand_correct', 'some') : store.commit('set_part_hand_correct', null);
          containsAllItems(part_hand_items, res) ? store.commit('set_part_hand_correct', 'all') : null;
          containsSomeItems(part_feet_items, res) ? store.commit('set_part_feet_correct', 'some') : store.commit('set_part_feet_correct', null);
          containsAllItems(part_feet_items, res) ? store.commit('set_part_feet_correct', 'all') : null;

          if (compare(res, correct_items)) {
            let session = '';
            (sessionStorage.getItem('rs-session-key')) && (session = JSON.parse(sessionStorage.getItem('rs-session-key')));
            (sessionStorage.getItem('vue-session-key')) && (session = JSON.parse(sessionStorage.getItem('vue-session-key')));
            let get_id = session.session_play;
            let data = {
              user: get_id,
              current_level: current_level,
              status: current_level === 'construction' ? 1 : 0
            };
            axios({
              method: 'POST',
              url: 'https://influencedigital.app/rscomponents/rs-frgame/de/api/v1/tc',
              data: data,
              headers: {
                "content-type": "application/x-www-form-urlencoded"
              }
            }).then(response => {
              console.log(response);
            }).catch((error) => {
              console.log(error);
              console.log(error.response);
              console.log(error.response.data);
            });
            setTimeout(function () {
              router.push({ name: 'complete', params: { level: current_level } });
              resetStores();
              localStorage.setItem('characterItems', JSON.stringify(['']));
            }, 3000);
          }
          // else if(compare(res, correct_items) && current_level != 'construction') {
          // }

        } else {
          store.commit('set_item_correct', 'false');
          removeNotification();
        }

      }

      const mobiCheckTarget = function (e) {
        let mobile_target = store.getters.mobile_current_target;
        if (e.dataset.target == 1 && mobile_target === 'CIRCLE-HEAD') {
          // console.log('correct')
          return true;
        } else if (e.dataset.target == 2 && mobile_target === 'CIRCLE-BODY') {
          // console.log('correct')
          return true;
        } else if (e.dataset.target == 3 && mobile_target === 'CIRCLE-RIGHT-HAND') {
          // console.log('correct')
          return true;
        } else if (e.dataset.target == 4 && mobile_target === 'CIRCLE-FEET') {
          // console.log('correct')
          return true;
        } else {
          store.commit('set_item_correct', 'false');
          store.commit('set_message', 'Item does not match the section of the body');
          removeNotification();
          removeMessage();
          return false;
        }
      }
      let mobilePickerTriggered = false;

      document.querySelectorAll('.mobile_picker ul li').forEach(function (e) {
        e.addEventListener('click', function () {
          document.querySelectorAll('.mobile_picker ul li').forEach(function (e) {
            e.classList.remove('selected');
          });
          e.classList.add('selected');
        });
      });

      document.querySelector('.mobile_picker .select_btn').addEventListener('click', function (el) {
        el.preventDefault();
        document.querySelectorAll('.mobile_picker ul li').forEach(function (e) {
          if (e.classList.contains('selected')) {
            // updateItems(e);
            // console.log(mobiCheckTarget(e));
            mobiCheckTarget(e) ? updateItems(e) : null;
            document.querySelector('.mobile_picker').classList.remove('picker_triggered');
            mobilePickerTriggered = false;
          }
        });
      });

      document.querySelector('#CIRCLE-HEAD').addEventListener('click', function () {
        store.commit('set_mobile_current_target', 'CIRCLE-HEAD');
        if (!mobilePickerTriggered) {
          document.querySelector('.mobile_picker').classList.add('picker_triggered');
          mobilePickerTriggered = true;
        }
        else {
          document.querySelector('.mobile_picker').classList.remove('picker_triggered');
          mobilePickerTriggered = false;
        }
      })

      document.querySelector('#CIRCLE-BODY').addEventListener('click', function () {
        store.commit('set_mobile_current_target', 'CIRCLE-BODY');
        if (!mobilePickerTriggered) {
          document.querySelector('.mobile_picker').classList.add('picker_triggered');
          mobilePickerTriggered = true;
        }
        else {
          document.querySelector('.mobile_picker').classList.remove('picker_triggered');
          mobilePickerTriggered = false;
        }
      })

      document.querySelector('#CIRCLE-RIGHT-HAND').addEventListener('click', function () {
        store.commit('set_mobile_current_target', 'CIRCLE-RIGHT-HAND');
        if (!mobilePickerTriggered) {
          document.querySelector('.mobile_picker').classList.add('picker_triggered');
          mobilePickerTriggered = true;
        }
        else {
          document.querySelector('.mobile_picker').classList.remove('picker_triggered');
          mobilePickerTriggered = false;
        }
      })

      document.querySelector('#CIRCLE-FEET').addEventListener('click', function () {
        store.commit('set_mobile_current_target', 'CIRCLE-FEET');
        if (!mobilePickerTriggered) {
          document.querySelector('.mobile_picker').classList.add('picker_triggered');
          mobilePickerTriggered = true;
        }
        else {
          document.querySelector('.mobile_picker').classList.remove('picker_triggered');
          mobilePickerTriggered = false;
        }
      })

      // MOBILE PICKER FUNCTIONALITY // <end>
      // MOBILE MENU FUNCTIONALITY // <start>

      if (document.querySelector('.mobile_trigger')) {
        document.querySelector('.mobile_trigger').addEventListener('click', function () {
          if (!document.querySelector('.info_container').classList.contains('info_triggered')) {
            document.querySelector('.info_container').classList.add('info_triggered');
          }
          else {
            document.querySelector('.info_container').classList.remove('info_triggered');
          }
        });
      }

      // MOBILE MENU FUNCTIONALITY // <end>

    }, 3000);

  }
});


// Vue.directive('mobile-picker', {
//   // When the bound element is inserted into the DOM...
//   inserted: function (el) {
//     // Focus the element
//     document.querySelectorAll('.mobile_picker > ul > li').forEach(function (item) {
//       var counter;
//       item.addEventListener('click', function(){
//         if(document.querySelector('.mobile_picker > ul > .selected')){
//         document.querySelector('.mobile_picker > ul > .selected').classList.remove('selected');
//         }
//         this.classList.add('selected');
//       });
//     });
//   }
// })